import React from "react";
import { Link, useLocation } from "react-router-dom";
import './Footer.css';

function Footer() {
  const { pathname} = useLocation();
  const accountMenuCheck = (pathname === '/' || pathname === '/not-authorize') ? true : false;

  if(accountMenuCheck) return null;
  
  return (
    <>
      <footer className="footer">
        <div className="footer-right">
          &#169; 2024. See Terms of Use for more information.
        </div>
        <div className="footer-left">
          <Link style={{borderRight:'1px solid #53565A'}}>Legal</Link>
          <Link>Privacy</Link>
        </div>
      </footer>
    </>
  );
}

export default Footer;